import { LDUser } from 'launchdarkly-js-client-sdk';
import { isEqual } from 'lodash/fp';

export const areUsersEqual = (user1: LDUser, user2: LDUser): boolean => {
    if (user1.anonymous === true && user2.anonymous === true) {
        const { key: _user1Key, ...comparableUser1 } = user1;
        const { key: _user2Key, ...comparableUser2 } = user2;
        return isEqual(comparableUser1, comparableUser2);
    }

    return isEqual(user1, user2);
};
